import React, { useState } from "react";
import DataTable from "../../components/DataTable";
import PageWrapperForm from "../../components/PageWrapperForm";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { UserRechargeCommission } from "../../config/tableConfigs";

import DeleteModal from "../../components/DeleteModal";
import { useSession } from "hooks/useSession";
import { useTableData } from "hooks/useTableData";

const UserCommissionManager = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh] = useState(0); 
  const {userid} = useSession(); // 🔄 trigger refresh

  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };



  const tableData = useTableData(
    `https://pro.mokshiq.in/retailer_commission?id=${userid}`,
    UserRechargeCommission,
   // 👈 hook re-fetches when refresh changes
  );

  const handleView = (report) => {
    console.log("Viewing report:", report);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setModalShow(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deletescheme1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)) {
      console.log("Deleting selected records:", selectedIds);
      // call delete API → then refresh
      setRefresh((prev) => prev + 1);
    }
  };

  // ✅ Handle successful form submission
  const handleFormSuccess = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setModalShow(false)
  };

  // ✅ Handle successful deletion
  const handleDeleteSuccess = () => {
    console.log("Scheme deleted successfully, refreshing data...");
    setRefresh((prev) => prev + 1);
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Custom Header replacing PageWrapperForm */}
        <div className="row m-1 mb-4">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title fw-bold" style={{ color: "#1a1a1a", fontSize: "1.8rem", marginBottom: "4px" }}>Recharge & Bill Payment Commission</h4>
              <div className="d-flex align-items-center gap-2 mb-0" style={{ fontSize: "13.5px", fontWeight: "500" }}>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2", display: "flex", alignItems: "center" }}>
                  <i className="iconoir-home-alt f-s-16"></i>
                </a>
                <span style={{ color: "#a0a5b1" }}>/</span>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2" }}>
                  Recharge & Bill Payment Commission
                </a>
              </div>
            </div>

            <div>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center p-0"
                onClick={handleAddUser}
                style={{
                  backgroundColor: "#7e57c2", borderColor: "#7e57c2", borderRadius: "8px", width: "44px", height: "44px", minWidth: "44px", maxWidth: "44px"
                }}
              >
                <i className="iconoir-user" style={{ fontSize: "20px" }}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Main Card with Banner */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0" style={{ borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" }}>
              <div className="card-body p-4">
                <div style={{
                  backgroundColor: "#f4f3fb", borderRadius: "12px", padding: "16px 24px",
                  marginBottom: "24px", display: "flex", alignItems: "center", gap: "16px"
                }}>
                  <div style={{
                    background: "#e4dff4", borderRadius: "12px", width: "48px", height: "48px",
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                  }}>
                    <i className="ph-duotone ph-wallet" style={{ fontSize: "24px", color: "#7e57c2" }}></i>
                  </div>
                  <div>
                    <h5 style={{ margin: 0, fontWeight: "600", color: "#1a1a1a" }}>Recharge & Bill Payment Commission</h5>
                    <span style={{ fontSize: "14px", color: "#6c757d" }}>View and manage recharge & bill payment commission</span>
                  </div>
                </div>

                <DataTable
                  config={UserRechargeCommission}
                  tableData={tableData}
                  onView={handleView}
                  onEdit={handleEditUser}
                  onDelete={handleDelete}
                  onExport={handleExport}
                  onDeleteSelected={handleDeleteSelected}
                />
              </div>
            </div>
          </div>
        </div>

        <DeleteModal
          deleteid={selectedUser?.id}
          id="deletescheme1"
          title="Delete Scheme"
          message="Are you sure you want to delete this scheme?"
          apiUrl="https://pro.mokshiq.in/scheme_manager_action"
          onSuccess={handleDeleteSuccess} // ✅ Pass success callback
        />
      </div>
    </main>
  );
};

export default UserCommissionManager;